import get from 'lodash/get';

export default state => get(state, 'shops.map.currentPage', 1);
